var _defs, _circle, _circle2, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew248({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.92,
    cy: 8,
    r: 1.49
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 14.08,
    cy: 8,
    r: 1.49
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 1.92,
    y1: 6.51,
    x2: 14.08,
    y2: 6.51
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 1.92,
    y1: 9.49,
    x2: 14.08,
    y2: 9.49
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew248);
export default __webpack_public_path__ + "static/media/Symbolpack_New_248.11fe6d5b4f34a312062779193b72220a.svg";
export { ForwardRef as ReactComponent };